module.exports = __webpack_public_path__ + "images/93cbdb516c6db9661a81dfb7550292b5.svg";